import React, { useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { useCookies } from 'react-cookie';
import { IDeployStoryProps } from 'utils/types/platformTypes';
import { theme } from 'utils/style/theme';
import { projectDeployApi } from 'apis/platform/projectDeployApis';
import DefaultInput from 'components/input/DefaultInput';
import LoadingPage from 'pages/LoadingPage';
import VerticalForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultButton from 'components/button/DefaultButton';
/**
 * * 플랫폼 관리 - 작품 배포 모달
 */

interface InterfaceProps {
  projectTitle?: string;
  visible?: boolean;
  setVisible: (p: boolean) => void;
  record?: IDeployStoryProps | undefined; // 선택한 작품 정보
  fetchData: () => void;
}

const LiveDeployModal = (props: InterfaceProps) => {
  const { record, fetchData, visible, setVisible } = props;

  const [cookies] = useCookies();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [title, setTitle] = useState<string>();
  const [reason, setReason] = useState<string>();

  // * kjiyu * e: target: {HTMLInputElement}
  const handleInput = (e: { target: HTMLInputElement }): void => {
    if (e.target.name === 'title') {
      setTitle(e.target.value);
    }
    if (e.target.name === 'reason') {
      setReason(e.target.value);
    }
  };

  /// 라이브 배포
  const handleSubmit = async () => {
    if (title !== record?.title) {
      alert('프로젝트명을 정확히 기입해주세요.');
      return;
    }
    if (!reason) {
      alert('배포사유를 기입해주세요.');
      return;
    }

    setIsLoading(true);

    // const res = await projectDeployApi.deploy(
    //   cookies.loginAdmin.user_id,
    //   record?.project_id,
    //   reason,
    //   'ifyou',
    // );
    //
    // if (res !== false) {
    //   message.success('작품의 서버 배포가 완료되었습니다.');
    //   setIsLoading(false);
    //   handleClose();
    //   fetchData();
    // } else {
    //   setIsLoading(false);
    // }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible(false);
  };
  return (
    <>
      <LoadingPage isLoading={isLoading} />
      <DefaultModal
        title='LIVE 배포'
        visible={visible}
        onCancel={handleClose}
        footer={<DefaultButton onClick={handleSubmit}>배포하기</DefaultButton>}
      >
        <VerticalForm>
          <ProjectTitleSection>
            <span>{record?.title}</span> 작품을 라이브 서버로 배포합니다.
          </ProjectTitleSection>

          <DefaultInput
            title='프로젝트명'
            name='title'
            id={title}
            value={title}
            onChange={handleInput}
            placeholder='작품명을 타이핑 해주세요.'
            style={{ marginBottom: theme.margins.bottomInModal }}
          />
          <DefaultInput
            title='배포 사유'
            name='reason'
            value={reason}
            onChange={handleInput}
            placeholder='배포 사유를 입력하세요.'
          />

          <WarningSection>
            배포는 실제 게임을 이용 중인 유저들에게 영향을 줄 수 있는 <br />
            중요한 프로세스입니다. 반드시 작품명을 확인해주세요.
          </WarningSection>
        </VerticalForm>
      </DefaultModal>
    </>
  );
};

export default LiveDeployModal;
const ProjectTitleSection = styled.div`
  /* background-color: aliceblue; */
  text-align: center;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    color: #3e38ff;
    font-weight: 800;
  }
`;

const WarningSection = styled.div`
  margin-top: 20px;
  text-align: center;
  color: red;
`;
